export default __webpack_public_path__ + "static/media/backgroundLoginBankzz.26fafaef.svg";